import React, { useState } from "react";
import { useCorporate } from "../CorporateContext";
import { Skeleton } from "../../../../ui/skeleton";
import { Separator } from "../../../../ui/separator";
import BenefitsHeader from "./benefits/BenefitsHeader";
import SignalCatalogPanel from "./benefits/SignalCatalogPanel";
import MyBenefitsSection from "./benefits/MyBenefitsSection";
import GlobalCatalogSection from "./benefits/GlobalCatalogSection";
import UtilizationSection from "./benefits/UtilizationSection";

/**
 * Benefits Intelligence admin tab. The full design and API contract lives in
 * src/Pages/Admin/Corporates/BENEFITS_API.md. This tab composes:
 *   - Header (master switch + governance note + signal catalog trigger)
 *   - My benefits (corporate-owned CRUD)
 *   - Available global benefits (opt-in + per-corp overrides)
 *   - Utilization (aggregate-only analytics)
 */
const Benefits = () => {
  const { corporate, loading } = useCorporate();
  const [signalCatalogOpen, setSignalCatalogOpen] = useState(false);

  if (loading) {
    return (
      <div className="space-y-3">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    );
  }

  if (!corporate) return null;

  const benefitsEnabled = corporate.benefits_enabled === true;

  return (
    <div className="space-y-8">
      <BenefitsHeader onOpenSignalCatalog={() => setSignalCatalogOpen(true)} />

      <SignalCatalogPanel
        open={signalCatalogOpen}
        onOpenChange={setSignalCatalogOpen}
      />

      <Separator />

      <MyBenefitsSection benefitsEnabled={benefitsEnabled} />

      <Separator />

      <GlobalCatalogSection />

      <Separator />

      <UtilizationSection benefitsEnabled={benefitsEnabled} />
    </div>
  );
};

export default Benefits;
